import { lazy, type ComponentType, type LazyExoticComponent } from "react";

const RELOAD_FLAG = "chunk-reload-at";
const RELOAD_WINDOW_MS = 10_000;

/** Reloads once to pick up the new deploy's index.html; returns false if it already did so just now. */
export function reloadOnceForStaleChunk(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0);
    if (Date.now() - last < RELOAD_WINDOW_MS) return false;
    sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  } catch {
    // sessionStorage unavailable — reload anyway
  }
  window.location.reload();
  return true;
}

/** `lazy()` that recovers from a stale hashed chunk (404 after a deploy) by reloading once. */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      return await factory();
    } catch (e) {
      if (reloadOnceForStaleChunk()) return new Promise<{ default: T }>(() => {});
      throw e;
    }
  });
}
